import { useEffect, useState } from "react";
import api from "../api/axios";
import { NewsCard } from "./JobNewsSection";
import Navbar from "./Navbar";   // adjust the path to where Navbar.jsx is

const CATEGORIES = [
  ["", "All categories"],
  ["hiring", "Hiring"],
  ["layoffs", "Layoffs"],
  ["campus", "Campus Hiring"],
  ["government", "Govt Jobs"],
];

export default function JobNews() {
  const [category, setCategory] = useState("");
  const [page, setPage] = useState(1);
  const [res, setRes] = useState({ data: [], last_page: 1 });
  const [loading, setLoading] = useState(true);

  const [user] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    setLoading(true);
    api
      .get("/news", { params: { category, page, per_page: 12 } })
      .then((r) => setRes(r.data))
      .catch(() => setRes({ data: [], last_page: 1 }))
      .finally(() => setLoading(false));
  }, [category, page]);

  return (
    <div
      className="min-h-screen text-[#1E0F3D]"
      style={{ background: "linear-gradient(180deg, #FAF3FC 0%, #FDF2F8 100%)" }}
    >
      <Navbar user={user} />

      <main className="max-w-6xl mx-auto px-6 lg:px-8 py-10">
        {/* header row: title left, filter right */}
        <div className="flex flex-wrap items-start justify-between gap-4 mb-8">
          <div>
            <h1
              className="text-3xl font-bold"
              style={{
                backgroundImage: "linear-gradient(90deg,#7C3AED,#DB2777)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Jobs &amp; Career News
            </h1>
            <p className="text-gray-500 mt-1">Hiring drives, layoffs and job market updates in one place.</p>
          </div>

          <select
            value={category}
            onChange={(e) => { setCategory(e.target.value); setPage(1); }}
            aria-label="Filter news by category"
            className="bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-[#1E0F3D] focus:outline-none focus:ring-2 focus:ring-[#7C3AED]/40"
          >
            {CATEGORIES.map(([val, label]) => (
              <option key={val} value={val}>{label}</option>
            ))}
          </select>
        </div>

        {/* content */}
        {loading ? (
          <div className="border border-dashed border-gray-300 rounded-xl py-16 text-center text-gray-400">
            Loading news...
          </div>
        ) : res.data.length === 0 ? (
          <div className="border border-dashed border-gray-300 rounded-xl py-16 px-6 text-center text-gray-400">
            No news yet. Articles appear here once the latest hiring and job market updates are fetched.
          </div>
        ) : (
          <>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {res.data.map((n) => <NewsCard key={n.id} n={n} />)}
            </div>

            <div className="flex items-center justify-center gap-4 mt-10">
              <button
                disabled={page <= 1}
                onClick={() => setPage((p) => p - 1)}
                className="px-4 py-2 rounded-lg border border-gray-200 bg-white text-sm font-medium disabled:opacity-40"
              >
                Prev
              </button>
              <span className="text-sm text-gray-500">Page {page} of {res.last_page}</span>
              <button
                disabled={page >= res.last_page}
                onClick={() => setPage((p) => p + 1)}
                className="px-4 py-2 rounded-lg border border-gray-200 bg-white text-sm font-medium disabled:opacity-40"
              >
                Next
              </button>
            </div>
          </>
        )}
      </main>
    </div>
  );
}